import { css } from 'styled-components'
import { theme } from '../../config/theme'

export type TypographyWeights = 'bold' | 'medium' | 'regular'

export type TypographyColor = string

export interface TypographyProps<Level extends number> {
  level?: Level
  weight?: 'bold' | 'medium' | 'regular'
  className?: string
  children: React.ReactNode
}

/**
 * @deprecated use weight from theme
 */
export const weightMap = theme.font.weight

export const getFontWeight = (weight?: TypographyWeights) =>
  theme.font.weight[weight || 'regular']

export type TypographyCssProps = {
  $weight?: TypographyWeights
}
export const typographyCss = css<TypographyCssProps>`
  all: unset;
`
